export default {
    props: {
        do: Function,
        condition: {
            type: Function,
            default: () => () => true,
        }
    },
    mounted () {
        const listener = (e) => {
            if (this.condition(e.key,e.altKey,e.ctrlKey,e.shiftKey)) {
                this.do()
            }
        }
        document.addEventListener('keydown', listener)
        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('keydown', listener)
        })
    },
    render () {
        return this.$slots.default[0]
    }
}
